const preOauthLoginTemplate = `<pwr-oauth-preoauth-login></pwr-oauth-preoauth-login>`;

export default preOauthLoginTemplate;
